<template>
  <v-app class="v-application">
    <!--    <v-navigation-drawer-->
    <!--        app permanent expand-on-hover class="top-z-index"-->
    <!--        mini-variant-->
    <!--    >-->
    <v-app-bar
        v-if="$vuetify.breakpoint.mobile"
        app color="primary" dark clipped-left dense height="64">
      <v-app-bar-nav-icon @click="drawer=!drawer"></v-app-bar-nav-icon>
      <v-toolbar-title>ComponentDB</v-toolbar-title>
    </v-app-bar>
    <v-navigation-drawer
        app
        class="top-z-index mr-6"
        clipped
        :expand-on-hover="!$vuetify.breakpoint.mobile"
        v-model="drawer"
        :mini-variant="!$vuetify.breakpoint.mobile"
        :permanent="!$vuetify.breakpoint.mobile"
        width="400"
    >
      <v-list nav dense>
        <v-list v-if="getLoggedIn">
          <v-list-item class="px-1">
            <v-list-item-avatar v-if="getUser.avatar">
              <v-img src="getUser.avatar"></v-img>
            </v-list-item-avatar>
            <v-list-item-avatar
                v-else
                color="quaternary"
                size="36"
            >
              <span class="white--text text-md-h5 text-lg-h6 my-3">{{ getUser.initials }}</span>
            </v-list-item-avatar>
            <locale-changer></locale-changer><a href="/htmx_core/"><v-icon>mdi-web</v-icon></a>
          </v-list-item>

          <v-list-item link>
            <v-list-item-content>
              <v-list-item-title class="text-md-h5 text-lg-h6">
                {{ getUser.username }}
              </v-list-item-title>
              <v-list-item-subtitle>{{ getUser.email }}</v-list-item-subtitle>
            </v-list-item-content>
          </v-list-item>
        </v-list>
      </v-list>
      <v-divider></v-divider>

      <v-list-group :value="false" :prepend-icon=section.icon no-action v-if="isShowSection(section)"
                    v-for="(section, j) in menu" :key="j" color="primary">
        <template v-slot:activator>
          <v-list-item-content class="text-md-h5 text-lg-h6">
            <v-list-item-avatar v-if="section.img">
              <v-img :src="section.img"></v-img>
            </v-list-item-avatar>
            <router-link v-else :to="{name:section.component}" v-text="section.title"></router-link>
          </v-list-item-content>
        </template>
        <v-list-item v-for="(subsection, i) in section.subsections" :key="i" link
                     v-if="subsection.requiresAuth === getLoggedIn && isShowSection(subsection)">
          <!--        <v-list-item v-for="(subsection, i) in section.subsections" :key="i" link v-if="isShowSection(subsection)">-->
          <v-list-item-icon>
            <v-icon v-if="subsection.icon" v-text="subsection.icon" color="primary"></v-icon>
            <span v-if="subsection.emoji"> {{ subsection.emoji }}</span>
          </v-list-item-icon>
          <v-list-item-title v-if="!!subsection.component" class="text-md-h5 text-lg-h6">
            <router-link :to="{name:subsection.component, params:subsection.params}"
                         v-text="subsection.title"></router-link>
          </v-list-item-title>
          <v-list-item-title v-if="!!subsection.path" class="text-md-h5 text-lg-h6">
<!--            <router-link :to="{path:subsection.path}" v-text="subsection.title"></router-link>-->
            <a :href="subsection.path" rel="noopener noreferrer" v-text="subsection.title"></a>
          </v-list-item-title>
        </v-list-item>
      </v-list-group>

    </v-navigation-drawer>
    <v-main>
      <v-sheet :class="$vuetify.breakpoint.mobile?'':'ml-3'">
        <router-view></router-view>
      </v-sheet>
      <CommonConfirmDialog class="top-z-index"></CommonConfirmDialog>
    </v-main>

  </v-app>
</template>

<script>

import {mapActions, mapGetters} from "vuex";
import LocaleChanger from "@/localChanger";
import CommonConfirmDialog from "@/components/Common/CommonConfirmDialog";
import {useAggregateStore} from "@/store/CommonStore/baseAggregateStore";
import {watch} from "vue";

export default {
  name: 'App',
  components: {
    LocaleChanger,
    CommonConfirmDialog
  },
  metaInfo: {
    title: 'App',
    titleTemplate: '%s | Zero Pro',
    htmlAttrs: {lang: 'en'},
    meta: [
      {charset: 'utf-8'},
      {name: 'viewport', content: 'width=device-width, initial-scale=1'},
    ],
  },

  computed: {
    ...mapGetters(['getLoggedIn', 'getUser']),

  },

  methods: {
    ...mapActions(['fetchLoginUser']),
    isShowSection(section) {
      // console.log('User roles', section.title, section, this.getUser)
      return (!section.requiresAuth || this.getLoggedIn) &&
          (this.getUser.superuser || (section.requiresModel == null) || this.getUser.roles.includes(section.requiresModel))
    },
  },

  setup() {
    // console.log('setup', storeName, uidItem, modalDialog)
    let aggregateStore = useAggregateStore()
    watch(
        () => aggregateStore.rootData,
        (newValue, oldValue) => {
          aggregateStore.watchRootData(newValue)
        },
        {deep: true}
    );

    return {}
  },

  mounted() {
    this.fetchLoginUser()
  },

  data() {
    return {
      storeConfirmStore: null,
      drawer: false,
      menu: [
        {
          title: 'Personal information',
          icon: 'mdi-account',
          requiresAuth: false,
          subsections:
              [
                {component: 'AuthLogin', title: 'Login', icon: 'mdi-login', requiresAuth: false},
                {component: 'AuthLogout', title: 'Logout', icon: 'mdi-logout', requiresAuth: true},
                {component: 'TimeTrackerHumanInfo', title: 'HR data', icon: 'mdi-av-timer', requiresAuth: true},
              ]
        },
        {
          title: 'Master data',
          icon: 'mdi-factory',
          requiresAuth: true,
          requiresModel: 'Product',
          subsections:
              [
                // {component: 'CustomerOrderTable', title: 'Customer order', emoji: '🥇', requiresAuth: true},
                {path: window.location.origin + '/production/customer_order/', title: 'Customer order', icon: 'mdi-history', requiresAuth: true},
                {component: 'CoreComponentTable', title: 'Article', icon: 'mdi-chip', requiresAuth: true},
                {component: 'PartNumberTable', title: 'Part Number', icon: 'mdi-chip', requiresAuth: true},
                {component: 'ClientTable', title: 'Partners', emoji: '🤴', requiresAuth: true},
                {component: 'MaterialTable', title: 'Material', icon: 'mdi-history', requiresAuth: true},
                {path: window.location.origin + '/material/material/', title: 'Material', icon: 'mdi-cpu', requiresAuth: true},
                {component: 'MaterialLocationTable', title: 'Location', icon: 'mdi-history', requiresAuth: true},
              ]
        },
        {
          title: 'HR',
          icon: 'mdi-account-box-multiple-outline',
          requiresAuth: true,
          requiresModel: 'Time tracker',
          subsections:
              [
                {component: 'TimeTracker', title: 'Tracker', icon: 'mdi-av-timer', requiresAuth: true},
                {
                  component: 'HRAdmin',
                  title: 'Admin',
                  icon: 'mdi-account-supervisor-circle-outline',
                  requiresAuth: true,
                  requiresModel: 'Time tracker list',
                },
                {
                  component: 'HRConfig',
                  title: 'HRConfig',
                  icon: 'mdi-cog',
                  requiresAuth: true,
                  requiresModel: 'Time tracker list',
                },
                {
                  component: 'CalendarVacationTable',
                  title: 'Calendar',
                  icon: 'mdi-calendar-month',
                  requiresAuth: true,
                  requiresModel: 'Calendar vacation',
                },
              ]
        },
        {
          title: 'Batch Run',
          icon: 'mdi-calendar',
          requiresAuth: true,
          requiresModel: 'Marging scheduling',
          subsections: [
            {component: 'BatchRun', title: 'Batch Run', icon: 'mdi-view-week-outline', requiresAuth: true},
            {component: 'BatchRunHistoryList', title: 'History', icon: 'mdi-history', requiresAuth: true},
            {component: 'PBatchRunTable', title: 'BatchRun', icon: '', requiresAuth: true},
            {component: 'PCustomerOrderSoloTable', title: 'Customer order', icon: '', requiresAuth: true},
            {component: 'PVariantSoloTable', title: 'Variant', icon: '', requiresAuth: true},
            {component: 'PBatchRunTaskTable', title: 'BatchRun Task', icon: '', requiresAuth: true},
            {component: 'PVariantTaskTable', title: 'Variant Task', icon: '', requiresAuth: true},
          ],
        },
        // {
        //   title: 'MPN Component research',
        //   icon: 'mdi-feature-search',
        //   requiresAuth: true,
        //   requiresModel: 'MPN research',
        //   subsections:
        //       [
        //         {
        //           component: 'MPNResearch',
        //           title: 'MPN Research',
        //           icon: 'mdi-watermark',
        //           requiresAuth: true
        //         },
        //       ]
        // },

        {
          title: 'Master Configuration',
          icon: 'mdi-cogs',
          requiresAuth: true,
          requiresModel: 'Product',
          subsections:
              [
                // {
                //   component: 'ComponentCategoryTab',
                //   title: 'Component Categories',
                //   icon: 'mdi-package-variant',
                //   requiresAuth: true
                // },
                {component: 'PrinterQueueTable', title: 'Printer Queue', icon: 'mdi-table-large', requiresAuth: true},
                {component: 'CoreSubcategoryTable', title: 'Subcategory', icon: 'mdi-table-large', requiresAuth: true},
                {component: 'CoreCategoryTable', title: 'Category', icon: 'mdi-table-large', requiresAuth: true},
                {component: 'CoreCasePackageTable', title: 'CasePackage', icon: 'mdi-table-large', requiresAuth: true},
                {component: 'MachineTable', title: 'Machines', icon: 'mdi-table-large', requiresAuth: true},
                {component: 'TaskTypeTable', title: 'TaskType', icon: 'mdi-table-large', requiresAuth: true},
                {component: 'TaskTemplateTable', title: 'TaskTemplate', icon: 'mdi-table-large', requiresAuth: true},
                {
                  component: 'MaterialLocationTable',
                  title: 'Material location',
                  icon: 'mdi-map-marker-outline',
                  requiresAuth: true
                },
                {component: 'CoreProductOrderTable', title: 'ProductOrder', emoji: '🎛', requiresAuth: true},
                {component: 'ClientReplicaTable', title: 'ClientReplica', emoji: '🤴', requiresAuth: true},
                {component: 'CustomerOrderReplicaTable', title: 'CustomerOrderReplica', emoji: '🥇', requiresAuth: true},
                {component: 'QuoteReplicaTable', title: 'QuoteReplica', emoji: '🥕', requiresAuth: true},
                {component: 'ProductReplicaTable', title: 'ProductReplica', emoji: '🎛', requiresAuth: true},
                // {component: 'CoreBomTable', title: 'Bom', icon: 'mdi-history', requiresAuth: true},
                {component: 'CoreSpecAttrTable', title: 'Spec attribute', icon: 'mdi-history', requiresAuth: true},
                {
                  component: 'CoreSpecAttrComponentTable',
                  title: 'Spec attribute component',
                  icon: 'mdi-history',
                  requiresAuth: true
                },
                {component: 'RequestRawTable', title: 'Panasonic request raw', icon: 'mdi-history', requiresAuth: true},
                {component: 'CoreBatchRunTable', title: 'BatchRun', icon: 'mdi-history', requiresAuth: true},
                {component: 'BatchRunReplicaTable', title: 'BatchRun replica', icon: 'mdi-history', requiresAuth: true},
              ]
        },

        {
          title: 'Utilites',
          icon: 'mdi-tools',
          requiresAuth: true,
          requiresModel: 'Super',
          subsections:
              [
                // {component: 'HistoryTable', title: 'History', icon: 'mdi-history', requiresAuth: true},
                {
                  component: 'UserTable',
                  title: 'Account management',
                  icon: 'mdi-account-group',
                  requiresAuth: true,
                },
                // {component: 'StoreDocList', title: 'Documents store', icon: 'mdi-store-outline', requiresAuth: true},
                // {component: 'StoreFileList', title: 'Files store', icon: 'mdi-file-multiple', requiresAuth: true},
                // {
                //   component: 'LibraryTopicTable',
                //   title: 'Library topic',
                //   icon: 'mdi-file-document-multiple-outline',
                //   requiresAuth: true
                // },
                // {
                //   component: 'LibraryDocTable',
                //   title: 'Library doc',
                //   icon: 'mdi-file-document-outline',
                //   requiresAuth: true
                // },
                // {component: 'LibraryFileTable', title: 'Library file', icon: 'mdi-file-outline', requiresAuth: true},
                // {component: 'BrandList', title: 'Brands', icon: 'mdi-watermark', requiresAuth: true},
                // {component: 'BrandProviderList', title: 'Providers', icon: 'mdi-face-agent', requiresAuth: true},
                // {component: 'BrandComponentList', title: 'MPN', icon: 'mdi-chip', requiresAuth: true},
                // {component: 'BrandComponentProviderComponent', title: 'P/N', icon: 'mdi-memory', requiresAuth: true},
                {component: 'PrinterQueueTable', title: 'Print label', icon: 'mdi-printer', requiresAuth: true},
                {component: 'WorkerTable', title: 'Workers', icon: 'mdi-iobroker', requiresAuth: true},
                {component: 'TaskTable', title: 'Tasks', icon: 'mdi-cog-clockwise', requiresAuth: true},
                {component: 'SystemPanel', title: 'SystemPanel', icon: 'mdi-cog-outline', requiresAuth: true},
                {component: 'CoreChangeLogTable', title: 'CoreChangeLog', icon: 'mdi-cog-outline', requiresAuth: true},
              ]
        },

        {
          title: 'Material',
          icon: 'mdi-chip',
          requiresAuth: true,
          requiresModel: 'Material',
          subsections:
              [
                {component: 'PrinterQueueTable', title: 'Printer queue', icon: 'mdi-history', requiresAuth: true},
                {component: 'MaterialEventTable', title: 'Material Event', icon: 'mdi-history', requiresAuth: true},
                // {component: 'MaterialActionPanel', title: 'Action panel', icon: 'mdi-history', requiresAuth: true},
                {
                  component: 'MaterialDeliveryTable',
                  title: 'Material delivery',
                  icon: 'mdi-history',
                  requiresAuth: true
                },
                {
                  component: 'MaterialStepperQR',
                  title: 'Material registration',
                  icon: 'mdi-history',
                  requiresAuth: true
                },
              ]
        },
      ],
    }
  },
};

</script>

<style scoped lang="scss">
* {
  z-index: 1;
}

.card_space {
  height: calc(100vh - 180px);
  overflow-y: auto;
}

.main_space {
  height: calc(100vh - 100px);
  overflow-y: auto;
}

.large-form {
  transform: scale(1.1);
  transform-origin: left;
}

.top-z-index {
  z-index: 200 !important;
}

</style>